<template>
  <div class="control">
    <el-container>
      <el-menu :default-active="defaultActive" :router="true" class="el-menu-vertical-demo" background-color="#2d2d2d"
        text-color="#ffffff" active-text-color="#EC8E00" :collapse="isCollapse">
        <el-menu-item @click="isCollapse = !isCollapse">
          <i class="el-icon-s-help"></i>
          <span slot="title">{{
            $store.state.shortName == null
              ? "上海益埃毕"
              : $store.state.shortName
          }}</span>
        </el-menu-item>
        <el-menu-item class="textEllipsis" :index="'/' + item.path" v-for="(item, index) in menuData" :key="index"
          :route="item.path">
          <i :class="item.icon" v-if="!item.icon.includes('ktr-')"></i>
          <i class="icon iconfont" :class="item.icon" v-else></i>
          <span slot="title" :style="{ letterSpacing: isEn ? 'normal' : '' }" :title="item.authName">{{ item.authName
          }}</span>
        </el-menu-item>
      </el-menu>
      <el-main>
        <router-view v-if="viewShow" ref="view"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { GetProjectInfo, GetRoleList, GetFunctionTemplate } from "@/setAxios";
export default {
  data() {
    return {
      isEn: this.$i18n.locale == 'en',
      viewShow: true,
      defaultActive: null,
      isCollapse: true,
      menuData: [
        { id: 101, authName: this.$t('项目设置侧边栏.项目信息'), icon: "el-icon-s-home", path: "ProjectInformation" },
        { id: 101, authName: this.$t('项目设置侧边栏.通知管理'), icon: "el-icon-s-opportunity", path: "informManagement" },
        { id: 103, authName: this.$t('项目设置侧边栏.应用导航'), icon: "el-icon-menu", path: "JobPage" },
        { id: 201, authName: this.$t('项目设置侧边栏.成员管理'), icon: "ktr-chengyuanguanli", path: "userManagement" },
        { id: 202, authName: this.$t('项目设置侧边栏.岗位权限'), icon: "ktr-qxsz", path: "PostPermissions" },
        { id: 701, authName: this.$t('项目设置侧边栏.资料管理'), icon: "ktr-zlgl", path: "dataDirectory" },
        { id: 701, authName: this.$t('项目设置侧边栏.进度状态设置'), icon: "ktr-jdzt", path: "progressShowState" },
        { id: 203, authName: this.$t('项目设置侧边栏.工程动态设置'), icon: "ktr-gcdt", path: "weiboLabel" },
        { id: 302, authName: this.$t('项目设置侧边栏.话题讨论标签'), icon: "ktr-httl", path: "topic" },
        { id: 301, authName: this.$t('项目设置侧边栏.工单标签设置'), icon: "ktr-gdbq", path: "singleSet" },
        { id: 1401, authName: this.$t('项目设置侧边栏.实景标签设置'), icon: "el-icon-price-tag", path: "tagSetting" },

      ],
    };
  },
  // 利用计算属性
  computed: {
    xidNameupdata() {
      return this.$store.state.xidName;
    },
    roleNameUpdata() {
      return this.$store.state.roleName;
    },
  },
  //监听执行
  watch: {
    xidNameupdata() {
      this.$router.push({
        name: "userProjectIndex",
      });
      window.location.reload();
      this.GetFunctionTemplate();
    },
    roleNameUpdata() {
      this.$router.push({
        name: "userProjectIndex",
      });
      window.location.reload();
    },
    $route: {
      handler: function (newRoute, oldRoute) {
        this.defaultActive = newRoute.path
      },
      // 深度观察监听
      deep: true
    },
  },
  methods: {
    defImg(event) {
      let img = event.srcElement;
      img.src = "./img/6.0/PC/风险管理.png";
      img.onerror = null; //防止闪图
    },
    handleOpen() { },
    handleClose() { },
    GetFunctionTemplate() {
      let that = this;
      GetFunctionTemplate({
        params: { companyId: localStorage.pid, xid: localStorage.xid },
      }).then((res) => {
        let list = that
          .getTreeDate(res.Data.projectfunctiontemplates, "fctm01", "fctm03")
          .map((item) => {
            item.children = [
              {
                id: "A" + item.fctm01,
                pid: item.fctm01,
                authName: "流程配置",
                pName: item.fctm02 + "流程配置",
                path: "flowLayout",
              },
              {
                id: "B" + item.fctm01,
                pid: item.fctm01,
                authName: "模版配置",
                pName: item.fctm02 + "模版配置",
                path: "modelConfigure",
              },
              {
                id: "C" + item.fctm01,
                pid: item.fctm01,
                authName: "数据查询",
                pName: item.fctm02 + "数据查询",
                path: "dataQuery",
              },
            ];
            return item;
          });
        that.menuData = that.menuData.concat(list);
      });
    },
    getTreeDate(data, idName, pidName) {
      let result = [];
      if (!Array.isArray(data)) {
        return result;
      }
      data.forEach((item) => {
        delete item.children;
      });
      let map = {};
      data.forEach((item) => {
        item["path"] = "ProjectMenuTemplate";
        map[item[idName]] = item;
      });

      data.forEach((item) => {
        let parent = map[item[pidName]];
        if (parent) {
          // item.parent=parent
          (parent.children || (parent.children = [])).push(item);
        } else {
          (item["icon"] = "el-icon-star-on"), result.push(item);
        }
      });
      return result;
    },
    // 点击项目进行跳转
    pushProject(item) {
      this.$store.state.xidName = item.proj07;
      localStorage.setItem("xid", item.proj01);
      this.$store.state.xid = item.proj01;
      localStorage.setItem("XmName", item.proj07);
      localStorage.setItem("XmBh", item.proj02);
      let params = {
        qid: localStorage.pid,
        xid: localStorage.xid,
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        if (res.Data.length == 0) {
          this.$message({
            type: "warning",
            message: this.$t('common.当前用户在此项目中未设置角色请联系管理员'),
          });
          return false;
        }
        this.$store.state.isClickProject = true;
        this.$store.state.jobs = res.Data;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].isPM) {
          this.$store.state.isProject = true;
        } else {
          this.$store.state.isProject = false;
        }
        this.$store.state.permissions =
          res.Data[0].roleRight == null
            ? null
            : res.Data[0].roleRight.split(",");
      });
    },
    out() {
      outLogin().then((res) => {
        localStorage.removeItem("token");
        this.$message({
          type: "success",
          message: this.$t('common.处理成功'),
        });
        this.$router.push({
          path: "/login",
        });
      });
    },
    // 执行刷新
    refreshData() {
      // this.$refs.view.getData();
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    },
  },
  created() {
    this.defaultActive = this.$route.path
    if (!this.$store.state.isClickProject) {
      this.$store.state.btnStyle[0] = "btns";
      this.$store.state.btnStyle[1] = "btns";
      this.$store.state.btnStyle[2] = "btnss";
      this.$store.state.btnStyle[3] = "btns";
      let params = {
        id: localStorage.xid,
      };
      GetProjectInfo({ params }).then((res) => {
        let item = res.Data;
        this.pushProject(item);
      });
    }

    if (this.$route.query && this.$route.query.hasOwnProperty("key")) {
      this.paths = JSON.parse(
        this.$UrlEncode.decode(this.$route.query.key)
      ).name;
    } else {
      this.paths = this.$route.fullPath.substr(1);
    }

    this.GetFunctionTemplate();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.el-menu-item i {
  color: #fff !important;
}

.flexLR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.control {
  width: 100%;
  height: 100%;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-container {
  display: -webkit-box;
  width: 100%;
  height: 100%;
}

.is-active {
  i {
    color: #EC8E00;
  }
}

/deep/.el-submenu__title i {
  color: #fff;
}

.el-menu-vertical-demo {
  height: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  overflow-x: hidden;
  // width: 22%;
  height: 100%;
}

/* 新增 */
.bg-cor {
  background-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}

.height100 {
  height: 100%;
}

.mar-r36p {
  margin-right: 36px;
}

.font-sz18 {
  font-size: 18px;
  font-weight: 600;
}
</style>